import styled from 'styled-components';

import { device } from '@/styles/helpers';

export interface ScRegistrationBannerProps {
  height: number;
}

export const ScRegBanner = styled.div<ScRegistrationBannerProps>`
  position: relative;
  width: 100%;
  display: flex;
  height: 100%;
  background-color: ${({ theme }) => theme.blackColor};
  min-height: ${({ height }) => `${height}px`};

  & > .slider-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  & > div {
    position: relative;
    padding-top: 104px;
    display: flex;
    align-items: center;
    z-index: 1;
  }

  @media (${device.mobile}) {
    display: flex;

    & > div {
      padding-top: 80px;
    }
  }
`;

export const ScRegBannerContainer = styled.div<{ isEstonia: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ isEstonia }) => (isEstonia ? 0 : '400px')} 1fr;
  margin-top: -32px;

  @media (${device.tablet}) {
    grid-template-columns: ${({ isEstonia }) => (isEstonia ? 0 : '350px')} 1fr;
    gap: 16px;
    margin-top: 0;
  }

  @media (${device.mobile}) {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding-bottom: 172px;
  }
`;

export const ScContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
  align-items: center;
  max-width: 720px;
  margin: 0 auto;

  & > .character-image {
    position: absolute;
    bottom: 48px;
    width: min(100%, 677px);
    height: clamp(80px, 100%, 325px);
    display: block;
    object-fit: contain;
    mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1) 45%,
      rgba(0, 0, 0, 0) 100%
    );
    display: flex;

    & > .characters {
      object-fit: contain;
    }

    @media (${device.mobile}) {
      order: 1;
      max-height: 150px;
      height: 100%;
      width: 100%;
      mask-image: none;
      margin-top: 16px;
      align-self: normal;
      left: 50%;
      transform: translate(-50%);
      bottom: -1px;
    }
  }

  @media (${device.mobile}) {
    gap: 16px;
    position: static;
  }
`;

interface ScBsnnerTitleProps {
  titleColor?: string;
}

export const ScBannerTitle = styled.h2<ScBsnnerTitleProps>`
  text-align: center;
  text-transform: uppercase;
  color: ${({ theme, titleColor }) => titleColor || theme.yellowColor};

  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 0.96px;

  @media (${device.mobile}) {
    font-size: 20px;
    line-height: 26px;
  }
`;

export const ScRegFormWrapper = styled.div`
  padding: 24px 16px;
  border-radius: 24px;
  background: ${({ theme }) => theme.whiteColor};
  z-index: 3;
  margin-bottom: 0;

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .reg-banner-btn {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    & > div {
      color: ${({ theme }) => theme.blackColor};

      .row {
        display: grid;
        grid-template-columns: 1.6fr 1fr;
        gap: 8px;
        margin-bottom: 5px;
        width: 100%;

        & > * {
          width: 100%;
        }
      }

      & > div:last-child {
        margin: 0 0 24px;
      }
    }

    .password-strength-checker {
      grid-template-columns: 1fr;
    }
  }

  @media (${device.mobile}) {
    margin-bottom: 0;

    form {
      & > div {
        .row {
          display: block;
          margin-bottom: 24px;

          & > *:first-child {
            margin-right: 0;
          }
        }
      }

      .reg-banner-btn button {
        width: 100%;
      }
    }
  }
`;

export const ScRegFormAbsoluteWrapper = styled(ScRegFormWrapper)`
  position: absolute;
  transition: top 0.3s ease-out;
  width: 400px;
  top: calc(50% + 24px);
  transform: translateY(-50%);

  @media (${device.tablet}) {
    width: 350px;
    top: 290px;
  }

  @media (${device.mobile}) {
    top: 314px;
    bottom: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (${device.mobileS}) {
    width: calc(100% - 42px);
  }
`;

export const ScBannerRegForm = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (${device.mobile}) {
    position: static;
    transform: none;
    order: 2;
  }
`;

export const ScRegFormPlug = styled(ScBannerRegForm)`
  height: 409px;

  @media (${device.mobile}) {
    height: 0;
  }
`;
